import { Component, Input, OnInit } from '@angular/core';
import { WidgetSize } from 'src/app/interfaces/perk';
import { User } from 'src/app/interfaces/user';
import { RegistrationProgressData, RegistrationProgressService } from 'src/app/services/registration-progress/registration-progress.service';

@Component({
  selector: 'app-register-stepper',
  templateUrl: './register-stepper.component.html',
  styleUrls: ['./register-stepper.component.scss'],
})
export class RegisterStepperComponent implements OnInit {
  @Input() progressData: RegistrationProgressData;
  @Input() user: User;

  public isFullNameRegistrationCompleted = true;
  public isPetChipNumberRegistrationCompleted = true;
  public isMembershipSelectionCompleted = true;
  public isWelcomePackSelectCompleted = true;
  public WidgetSize = WidgetSize;

  constructor(private registrationProgressService: RegistrationProgressService) {}

  public areTheInitialRegistrationStepsIncomplete() {
    const progress = this.registrationProgressService.getRegistrationProgressData(this.user);
    return (
      !progress.isFullNameRegistrationCompleted ||
      !progress.isPetChipNumberRegistrationCompleted ||
      !progress.isMembershipSelectionCompleted ||
      !progress.isWelcomePackSelectCompleted
    );
  }

  private handleRegistrationProgression(progressData: RegistrationProgressData) {
    this.isFullNameRegistrationCompleted = progressData.isFullNameRegistrationCompleted;
    this.isMembershipSelectionCompleted = progressData.isMembershipSelectionCompleted;
    this.isPetChipNumberRegistrationCompleted = progressData.isPetChipNumberRegistrationCompleted;
    this.isWelcomePackSelectCompleted = progressData.isWelcomePackSelectCompleted;
  }

  ngOnInit(): void {
    this.handleRegistrationProgression(this.progressData);
  }
}
